import { render, staticRenderFns } from "./CustomerTokens.vue?vue&type=template&id=5a4aed48&scoped=true"
import script from "./CustomerTokens.vue?vue&type=script&lang=ts"
export * from "./CustomerTokens.vue?vue&type=script&lang=ts"
import style0 from "./CustomerTokens.vue?vue&type=style&index=0&id=5a4aed48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4aed48",
  null
  
)

export default component.exports